<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
  <div>
    <nav-bar />

    <b-container
      fluid
      style="background: #f7f7fc"
      class="py-4 strata-plan-details"
    >
      <b-row>
        <b-col xl="8" lg="7" md="12" sm="12" class="mt-3 pl-lg-5 px-md-5">
          <div
            class="section-first px-5 py-5"
            style="
              background-color: #fff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);
            "
          >
            <h3
              style="color: #4682b4; font-size: 22px; font-weight: 800"
              class="mb-3"
            >
              Quote No. {{ quote.organization_id }}
            </h3>

            <div v-if="quote.is_work_order">
              <b-button
                v-if="quote.priority == 'high'"
                variant="danger"
                class="btn-high ml-2"
                >High Priority</b-button
              >
            </div>
            <div v-else class="mb-3">
              <b-button
                v-if="quote.is_private"
                class="btn-public px-4"
                >Private</b-button
              >
              <b-button v-else class="btn-public px-4"
                >Public</b-button
              >
              <b-button
                v-if="quote.priority == 'high'"
                variant="danger"
                class="btn-high ml-2"
                >High Priority</b-button
              >
            </div>

            <!-- job detail -->
            <div class="job-detail">
                <ul>
                    <li>
                        <span class="title">Job Title:</span>
                        <span class="sub-title">{{quote.job_title}}</span>
                    </li>

                    <li>
                        <span class="title">Strata Plan ID:</span>
                        <span class="sub-title">{{ quote.strata_plan.type }}-{{
                quote.strata_plan.strata_plan_number
              }}</span>
                    </li>

                    <li>
                        <span class="title">Building Manager:</span>
                        <span class="sub-title">{{ quote.strata_plan.building_manager_name }}</span>
                    </li>

                    <li class="d-flex">
                        <span class="title">Trade Type:</span>
                        <span class="sub-title" style="flex: 4;">
                            <button
                                v-for="category in quote.categories"
                                :key="'cat-' + category.id"
                                type="button"
                                class="btn mr-2"
                                style="border-radius: 20px;padding: 3px 14px;background-color: #e4daff;color: #2a00a2;font-size: 12px; margin-top: -2px;">
                                <i class="fas fa-tag mr-2"></i> {{ category.name }}
                            </button>
                        </span>
                    </li>
                </ul>
            </div>
            <!-- job detail ends -->

          <hr class="my-3">


                <div class="section-description">
                    <h4 style="font-size: 20px; color: #333333;" class="mt-4 mb-3">Quote Description</h4>
                    <p v-html="quote.description" style="font-size: 14px; color: 4F4F4F; line-height: 24px; ">
                    </p>

                </div>
          </div>

          <div
            class="work-session mt-4 pt-4"
            style="
              background-color: #ffffff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);
              padding-bottom: 5rem;">
            <b-tabs
              content-class="mt-3"
              class="manager-quote-tab ml-4"
              v-if="!workOrder"
            >
                 <b-tab :title="'MESSAGES'" active>

                  <div v-if="quote.business_invitation">

                    <div class="chat-main-box">
                    <h5>
                      {{activeChatBoxInfo.receiverBusinessDetails.company_name}}
                    </h5>
                  </div>


                  <div style="padding: 50px 50px 0px 50px; border: 1px solid lightgrey">
                  <b-row>
                    <div id="chat-message" class="chat-message mb-4" v-if="chatMessages.length > 0">
                      <b-col
                       v-for="message in this.chatMessages"
                        :key="`ch-m${message.timestamp}-${message.sending_user_id}-${message.receiving_user_id}`"
                        md="12"
                        :class="
                          activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id
                            ? 'sending-message mb-4'
                            : 'receiving-message mb-4'
                        "
                      >

                      <p  v-if="message.type == 'image'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1 p-0'
                              : 'chat-msg-left mb-1 p-0'
                          ">
                          <a :href="message.message" target="_blank"><img :src="message.message" width="200px;"></a>
                      </p>

                          <a  v-if="message.type == 'file'" :href="message.message" target="_blank">  <p :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'file mb-1'
                              : 'file mb-1'
                          ">
                         <pre :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{ message.file_name }}</pre>
                        </p></a>

                        <p  v-if="message.type == 'message'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1'
                              : 'chat-msg-left mb-1'
                          ">
                         <span :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#7D7C81;font-family:Lexend;margin-bottom:0px;' ">{{ message.message }}</span>
                        </p>


                        <div v-if="activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id" class="d-flex" style="justify-content: right">
                          <span  style="font-size:12px;color:grey;">   {{message.sending_business_details.company_name}} |  {{message.timestamp.seconds? momentDate(message.timestamp): ''}}</span>
                        </div>
                        <div v-else class="d-flex" style="justify-content: left">
                          <span  style="font-size:12px;color:grey;">   {{message.sending_business_details.company_name}} |   {{message.timestamp.seconds? momentDate(message.timestamp): ''}}</span>
                        </div>

                      </b-col>
                    </div>

                    <div v-else id="chat-message" class="chat-message mb-4" >
                        <b-col class="sending-message mb-4 text-right">
                            <p :class="'chat-msg-right mb-1'">
                              <pre :style="'color:#ffffff;font-family:Lexend;margin-bottom:0px;'">Start a chat by sending a message....</pre>
                            </p>
                        </b-col>
                    </div>

                  <div class="w-100 pb-4" v-if="quote.status_parsed != 'over-due' && quote.status != 'granted'">
                    <b-col md="12">
                      <div class="chatbox">
                        <b-textarea
                            class="mb-4"
                            @keydown.enter.exact.prevent
                            @keyup.enter.exact="sendMessage"
                            @keydown.enter.shift.exact="newline"
                            v-model="message"
                            placeholder="Enter a message here...">
                            <img src="http://localhost/strata/resources/assets/contractor.png"/>
                        </b-textarea>
                        <div class="chatbox-icons">
                            <div class="send-file icons-props">
                                <label for="file-input">
                                    <i class="fas fa-paperclip fa-lg"></i>
                                </label>
                                <input id="file-input" type="file" plain multiple @change="sendAttachment($event, 'file')"/>
                            </div>

                            <div class="send-img icons-props">
                                <label for="file-input2">
                                    <i class="fas fa-image fa-lg"></i>
                                </label>
                                <input id="file-input2" type="file" plain multiple @change="sendAttachment($event, 'image')"/>
                            </div>

                            <span class="send-icon" :disabled="message == ''" @click="sendMessage()"><i class="fas fa-paper-plane fa-lg"></i></span>
                        </div>
                      </div>

                        <!-- contractor -->
                        <!-- <b-row>
                            <b-col>
                                <label>Choose Image</label>
                            <b-file class="mt-3" plain multiple @change="sendAttachment($event, 'image')"></b-file>
                            </b-col>
                                <b-col>
                                <label>Choose File</label>
                                <b-file class="mt-3" plain multiple @change="sendAttachment($event, 'file')"></b-file>
                            </b-col>
                        </b-row> -->
                    </b-col>

                  </div>
                  </b-row>
                  </div>
                 <p v-if="quote.status_parsed == 'over-due'" style="color:rgb(233, 22, 22); font-size: 12px;" class="mt-3">The quote has already  expired. You cannot message right now.</p>
                  </div>
                 <div v-else>
                    <p>You have to be invited in this quote for sending messages</p>
                  </div>
              </b-tab>
            </b-tabs>



            <b-tabs
              content-class="mt-3"
              class="manager-quote-tab ml-4"
              v-if="workOrder"
            >
              <b-tab :title="'PROGRESS FILE'">
                <b-button
                  class="my-4"
                  variant="primary"
                  type="button"
                  style="border-radius: 5px; float: right; padding: 10px 15px"
                  v-if="addProgress == false && quote.schedule_inspection && quote.progress_percentage != 100"
                  @click="addProgress = true"
                >
                  Add Progress
                </b-button>
                <b-form @submit.prevent="submitProgressForm" v-if="addProgress">
                  <b-row class="my-4">
                    <b-col md="2">
                      <b-form-group label="Progress">
                        <b-form-select
                          v-model="progressForm.percentage"
                          :options="percentageOptions"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        label="Description"
                        v-slot="{ ariaDescribedby }"
                      >
                        <b-form-input
                          type="text"
                          v-model="progressForm.description"
                          :aria-describedby="ariaDescribedby"
                          placeholder="Description"
                          v-bind:class="{
                            'is-invalid':
                              progressForm.errors.has('description'),
                          }"
                        ></b-form-input>
                        <has-error
                          :form="progressForm"
                          field="description"
                        ></has-error>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group
                        class="position-relative"
                        label="Upload Document(s)"
                      >
                        <p class="upload-tab">
                          <SvgIcons
                            icon="upload-document-button"
                            width="25px"
                            height="20px"
                            svgClass="upload-docs"
                          />
                        </p>

                        <b-form-file
                          placeholder="Upload Files/Documents"
                          @change="progressFileAttachements($event, 'document')"
                          style="margin-top: 0px; padding: 38px 45px"
                          v-bind:class="{
                            'is-invalid':
                              progressForm.errors.has('attachment'),
                          }"
                        ></b-form-file>
                         <has-error style="padding: 20px"
                          :form="progressForm"
                          field="attachment"
                        ></has-error>
                      </b-form-group>


                      <b-button
                        class="my-2"
                        variant="danger"
                        type="button"
                        style="border-radius: 5px; float: right"
                        @click="addProgress = false"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        class="my-2 mr-3"
                        variant="primary"
                        type="submit"
                        style="border-radius: 5px; float: right"
                      >
                        Save
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
                <b-table
                  striped
                  hover
                  :items="progressFileItems"
                  :fields="progressFileFields"
                  show-empty
                >
                  <template v-slot:cell(Download)="row">
                    <p>{{row.item.quote.media[0].name}}</p>
                  </template>

                  <template #empty class="text-center">
                    The progress file is empty.
                  </template>
                </b-table>

                 <b-button
                  v-if="showMarkComplete == true && quote.status != 'verify-completed' && quote.status != 'completed'"
                  variant="success"
                  type="button"
                  style="border-radius: 5px; float: right; padding: 10px 15px"

                  @click="confirmMarkComplete()"
                >
                  Mark Complete
                </b-button>

                <b-button
                  v-if="showMarkComplete == false && quote.status == 'verify-completed' || quote.status == 'completed'"
                  variant="success"
                  type="button"
                  style="border-radius: 5px; float: right; padding: 10px 15px"
                  :disabled="true"
                >
                  Mark Completed
                </b-button>

                  <b-button
                  v-if="showMarkComplete == false && quote.status == 'verify-completed' && !quote.quote_invoice"
                  variant="primary"
                  type="button"
                  style="border-radius: 5px; float: right; padding: 10px 15px;margin-right:15px"

                  @click="$bvModal.show('invoice-modal')"
                >
                  Send Invoice
                </b-button>


                  <b-button
                  v-if="showMarkComplete == false && quote.status == 'verify-completed' && quote.quote_invoice"
                  variant="primary"
                  type="button"
                  style="border-radius: 5px; float: right; padding: 10px 15px;margin-right:15px"

                  @click="$bvModal.show('preview-invoice-modal')"
                >
                  Preview Invoice
                </b-button>

                   <b-modal id="preview-invoice-modal" size="lg" centered>
                      <template #modal-header>
                        <h2>Quote Preview</h2>
                        <p>Preview invoice details</p>
                      </template>

                  <template  #default  v-if="!invoiceSent">
                      <div v-if="!invoiceSent">
                        <span class="d-block"><b>Completed date: </b> {{quote.status_date}}</span>
                        <span class="d-block"><b>Variations:</b> ${{quote.quote_invoice.variation}}</span>
                        <span class="d-block"><b>Comment: </b>{{quote.quote_invoice.comment}}</span>
                        <span class="d-block"><b>Total Amount(ex. GST) :</b> ${{quote.business_invitation.amount}}</span>
                        <span class="d-block"><b>GST:</b> ${{quote.business_invitation.amount * 0.1}}</span>
                        <span class="d-block"><b>Total Amount:</b> ${{quote.quote_invoice.total_amount}}</span>
                        <hr>
                        <p>Invoice has been sent to <b>{{quote.business_invitation.sending_business.company_name}}</b></p>
                      </div>
                  </template>



                 <template #modal-footer ="{ close }">
                  <b-button size="sm" variant="primary" @click="close()">Ok</b-button>
                </template>

                </b-modal>

                <b-modal id="invoice-modal" size="lg" centered >
                  <template #modal-title>
                    <h2>Quote Details</h2>
                    <p style="font-size: 12px;font-weight: 600;color: #767b80;">Please confirm invoice details</p>
                  </template>

                  <template  #default  v-if="!invoiceSent">
                    <b-form role="form" ref="invoiceDetailForm">
                      <div v-if="!invoiceSent">
                        <span class="d-block">Completed date: {{quote.status_date}}</span>
                        <span class="d-block">Amount: ${{quote.business_invitation.amount}}</span>
                          <hr class="my-3">
                          <b-row>
                              <b-col md="4">
                                <b-form-group label="Varitations">
                                  <b-form-input
                                    v-model="invoiceDetailForm.variation"
                                    type="number"
                                    placeholder="$0"
                                    v-bind:class="{
                                      'is-invalid':
                                      invoiceDetailForm.errors.has('variation'),
                                    }">
                                    </b-form-input>
                                    <has-error
                                      :form="invoiceDetailForm"
                                      field="variation"
                                    ></has-error>
                                </b-form-group>
                              </b-col>
                              <b-col md="8">
                                <b-form-group label="Comments">
                                  <b-form-input
                                    v-model="invoiceDetailForm.comment"
                                    type="text"
                                    placeholder="note"
                                    v-bind:class="{
                                      'is-invalid':
                                      invoiceDetailForm.errors.has('comment'),
                                    }"
                                    ></b-form-input>
                                      <has-error
                                      :form="invoiceDetailForm"
                                      field="comment"
                                    ></has-error>
                                </b-form-group>
                              </b-col>
                          </b-row>
                        <div class="d-flex">
                          <div class="ml-auto">
                            <span class="d-block">Total(ex. GST): ${{(quote.business_invitation.amount + Number(invoiceDetailForm.variation)).toFixed(2)}}</span>
                            <span class="d-block">GST: ${{((quote.business_invitation.amount + Number(invoiceDetailForm.variation)) * 0.1).toFixed(2)}}</span>
                            <span class="d-block"><b>Total Amount: ${{((quote.business_invitation.amount + Number(invoiceDetailForm.variation)) * 0.1 + quote.business_invitation.amount + Number(invoiceDetailForm.variation)).toFixed(2)}}</b></span>
                          </div>
                        </div>
                      </div>
                           </b-form>
                  </template>
                  <template  #default  v-else>
                    <div style="padding:35px 20px;">
                        <p>Invoice has been sent to <b>{{quote.business_invitation.sending_business.company_name}}</b></p>
                    </div>
                  </template>
                <template #modal-footer v-if="!invoiceSent">
                  <b-button size="md" variant="primary" @click="submitInvoiceDetailForm">Send Invoice</b-button>
                  <b-button size="md" variant="primary"  @click="closeModal()">Skip</b-button>
                  <b-button size="md" variant="primary"  @click="previewInvoiceDetails">Preview</b-button>
                </template>

                 <template #modal-footer v-else>
                  <b-button size="md" variant="primary" @click="closeModal()">Ok</b-button>
                </template>

                </b-modal>
                <b-modal id="preview-invoice" size="xl" centered>
                  <div class="container">
                  <div class="row">
                      <div class="col-12">
                          <div class="card">
                              <div class="card-body p-0">
                                  <div class="row p-5">
                                      <div class="col-md-6 text-left">
                                        <p class="font-weight-bold mb-1">Invoice# 111</p>
                                        <p class="text-muted">Date: {{quote.status_date}}</p>
                                      </div>

                                      <div class="col-md-6 text-left">
                                          <img :src="$root.serverBasePath + '/strata.png'">
                                           <p class="font-weight-bold mb-1"><b>{{quote.business_invitation.sending_business.company_name}}</b></p>
                                      </div>
                                  </div>
                                  <div class="row pb-5 p-5">
                                    <div class="col-md-4">
                                       <p class="font-weight-bold mb-1">Bill To </p>
                                        <p class="mb-1">Name {{ quote.strata_plan.building_manager_name }} </p>
                                        <p class="mb-1">Address </p>
                                    </div>
                                      <div class="col-md-4">
                                          <p class="font-weight-bold mb-1">Quote No. {{ quote.organization_id }} </p>
                                          <p class="mb-1">Job Title: {{quote.job_title}} </p>
                                          <p class="mb-1">Strata Plan ID: {{quote.strata_plan.type}}-{{quote.strata_plan.strata_plan_number}} </p>
                                      </div>

                                      <div class="col-md-4 text-right">
                                          <p class="font-weight-bold mb-4">Comment: {{invoiceDetailForm.comment}}</p>
                                      </div>
                                  </div>

                                  <div class="row p-5">
                                      <div class="col-md-12">
                                          <table class="table">
                                              <thead>
                                                  <tr>
                                                      <th class="border-0 text-uppercase small font-weight-bold">ID</th>
                                                      <th class="border-0 text-uppercase small font-weight-bold">Amount</th>
                                                      <th class="border-0 text-uppercase small font-weight-bold">Variation</th>
                                                      <th class="border-0 text-uppercase small font-weight-bold">Total(ex. GST)</th>
                                                      <th class="border-0 text-uppercase small font-weight-bold">GST</th>
                                                      <th class="border-0 text-uppercase small font-weight-bold">Total Amount</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  <tr>
                                                      <td>1</td>
                                                      <td>${{quote.business_invitation.amount}}</td>
                                                      <td>${{invoiceDetailForm.variation}}</td>
                                                      <td>${{(quote.business_invitation.amount + Number(invoiceDetailForm.variation)).toFixed(2)}}</td>
                                                      <td>${{((quote.business_invitation.amount + Number(invoiceDetailForm.variation)) * 0.1).toFixed(2)}}</td>
                                                      <td>${{((quote.business_invitation.amount + Number(invoiceDetailForm.variation)) * 0.1 + quote.business_invitation.amount + Number(invoiceDetailForm.variation)).toFixed(2)}}</td>
                                                  </tr>
                                              </tbody>
                                          </table>
                                      </div>
                                  </div>

                                  <div class="d-flex flex-row-reverse bg-dark text-white p-4">
                                      <div class="py-3 px-5 text-right">
                                          <div class="mb-2">Total amount</div>
                                          <div class="h2 font-weight-light">${{((quote.business_invitation.amount + Number(invoiceDetailForm.variation)) * 0.1 + quote.business_invitation.amount + Number(invoiceDetailForm.variation)).toFixed(2)}}</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
                 <template #modal-footer ="{ close }">
                  <b-button size="sm" variant="primary" @click="close()">Ok</b-button>
                </template>

                </b-modal>
              </b-tab>
              <b-tab :title="'AWARDED TENDER'+
                  (counts.awarded_tenders ? `[${counts.awarded_tenders}]` : '') " @click="getAwardedTenders">
                <b-table
                  striped
                  hover
                  :items="awardedTenderItems"
                  :fields="awardedTenderFields"
                  show-empty
                >
                  <template v-slot:cell(Files)="row">
                    <p v-for="(document, index) in row.item.awardedTenderDetails.media" :key="index"> <a :href="document.signed_url" target="_blank" download>{{document.name}}</a></p>
                  </template>

                   <template v-slot:cell(message)="row">
                    <i
                       class="fas fa-comment-alt"
                      style="font-size: 24px; color: #5F2EEA;"
                      @click="
                        openChat(
                          row.item.pivot.id,
                          row.item.pivot.sending_business,
                          row.item.business,
                          'Awarded Contractor'
                        )
                      "
                    ></i>
                   <span class="msg-count">{{row.item.unread_count}}</span>
                    </template>


                  <template #empty class="text-center">
                    No Data Found
                  </template>
                </b-table>

              </b-tab>
                  <b-tab :title-item-class=" activeTab == 'chat' ? 'd-block':'d-none'" :title="'MESSAGES'" :active="activeTab == 'chat'">

                  <div v-if="quote.business_invitation">
                    <div class="chat-main-box">
                    <h5>
                      {{activeChatBoxInfo.receiverBusinessDetails.company_name}}
                    </h5>
                  </div>

                  <div style="padding: 50px 50px 0px 50px; border: 1px solid lightgrey">
                  <b-row>
                    <div id="chat-message" class="chat-message mb-4" v-if="chatMessages.length > 0">
                      <b-col
                       v-for="message in this.chatMessages"
                        :key="`ch-m${message.timestamp}-${message.sending_user_id}-${message.receiving_user_id}`"
                        md="12"
                        :class="
                          activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id
                            ? 'sending-message mb-4'
                            : 'receiving-message mb-4'
                        "
                      >

                      <p  v-if="message.type == 'image'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1 p-0'
                              : 'chat-msg-left mb-1 p-0'
                          ">
                          <a :href="message.message" target="_blank"><img :src="message.message" width="200px;"></a>
                      </p>

                          <a  v-if="message.type == 'file'" :href="message.message" target="_blank">  <p :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'file mb-1'
                              : 'file mb-1'
                          ">
                         <pre :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{ message.file_name }}</pre>
                        </p></a>

                        <p  v-if="message.type == 'message'" :class="
                            activeChatBoxInfo.senderBusinessDetails.id ==
                            message.sending_business_id
                              ? 'chat-msg-right mb-1'
                              : 'chat-msg-left mb-1'
                          ">
                         <pre :style="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id ? 'color:#ffffff;font-family:Lexend;margin-bottom:0px;':'color:#000000;font-family:Lexend;margin-bottom:0px;' ">{{ message.message }}</pre>
                        </p>


                        <div v-if="activeChatBoxInfo.senderBusinessDetails.id ==
                          message.sending_business_id" class="d-flex" style="justify-content: right">
                          <span  style="font-size:12px;color:grey;">   {{message.sending_business_details.company_name}} |  {{message.timestamp.seconds? momentDate(message.timestamp): ''}}</span>
                        </div>
                        <div v-else class="d-flex" style="justify-content: left">
                          <span  style="font-size:12px;color:grey;">   {{message.sending_business_details.company_name}} |   {{message.timestamp.seconds? momentDate(message.timestamp): ''}}</span>
                        </div>

                      </b-col>


                      <!-- <b-col :v-if="activeChatBoxInfo.senderBusinessDetails.id == message.sending_business_id" md="12" class="sending-message">
                        <p class="chat-msg-right">
                          I'm all good.What about you?
                        </p>
                      </b-col> -->
                    </div>
                     <div v-else id="chat-message" class="chat-message mb-4" >
                          <b-col class="sending-message mb-4 text-right">
                            <p :class="'chat-msg-right mb-1'">
                              <pre :style="'color:#ffffff;font-family:Lexend;margin-bottom:0px;'">Start a chat by sending a message....</pre>
                            </p>
                        </b-col>
                      </div>

                  <div class="w-100 pb-4" v-if="quote.status_parsed != 'over-due'">
                    <b-col md="12">
                      <b-textarea
                            class="mb-4"
                            @keydown.enter.exact.prevent
                            @keyup.enter.exact="sendMessage"
                            @keydown.enter.shift.exact="newline"
                        v-model="message"
                        placeholder="Enter a message here..."
                      >
                      <img src="http://localhost/strata/resources/assets/contractor.png"/>
                      </b-textarea>

                    <b-row>
                      <b-col>
                          <label>Choose Image</label>
                     <b-file class="mt-3" plain multiple @change="sendAttachment($event, 'image')"></b-file>
                      </b-col>
                        <b-col>
                        <label>Choose File</label>
                          <b-file class="mt-3" plain multiple @change="sendAttachment($event, 'file')"></b-file>
                      </b-col>

                    </b-row>



                    </b-col>
                    <b-col md="12" class="text-right mt-3">
                      <b-button variant="primary" :disabled="message == ''" @click="sendMessage()"
                        >Send &nbsp;<i class="fa fa-paper-plane"></i
                      ></b-button>
                    </b-col>
                  </div>
                  </b-row>
                </div>
                 <p v-if="quote.status_parsed == 'over-due'" style="color:rgb(233, 22, 22);font-size: 12px;" class="mt-3">The auote has already expired. You cannot message right now.</p>
                </div>
                 <div v-else>
                    <p>You have to be invited in this quote for sending messages</p>
                  </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>

        <b-col
          class="mt-3 pl-lg-3 px-md-5 col-sm-12 col-md-12 col-lg-5 col-xl-4"
        >
          <div
            style="
              background-color: #fff;
              box-shadow: 1px 3px 10px rgba(233, 239, 244, 0.81);
            "
            class="section-second p-5"
          >
            <div v-if="!workOrder">
              <div class="quote-status mb-3">
                <button class="btn btn-stat btn-stat-open"
                  v-if="quote.status_parsed == 'open'"
                  >Open
                </button>

                <button class="btn btn-stat btn-stat-active"
                  v-if="quote.status_parsed == 'active'"
                  >Active
                </button>

                <button class="btn btn-stat"
                  v-if="quote.status_parsed == 'pending-approval'"
                  >Pending Approval
                </button>

                <button class="btn btn-stat"
                  v-if="quote.status_parsed == 'due'"
                  >Due Soon {{ "(" + subtractedDate + " Days Left)" }}
                </button>

                <button class="btn btn-stat btn-stat-overdue"
                  v-if="quote.status_parsed == 'over-due'"
                  >Overdue
                  {{ "(" + subtractedDate + " Days Passed)" }}
                </button>

                <button class="btn btn-stat"
                  v-if="quote.status_parsed == 'draft'"
                  >Draft
                </button>

                <button class="btn btn-stat"
                  v-if="quote.status_parsed == 'completed'"
                  >Completed
                </button>
              </div>

              <div v-if="quote.status_parsed == 'over-due'">
                <p style="color:rgb(233, 22, 22); margin-top: 10px; font-size: 14px;">The Quote has already expired.</p>
                 <div class="mt-4"><hr /></div>
              </div>

              <!-- Tender Submitting Form -->
              <div v-if="quote.business_invitation && quote.status_parsed != 'over-due'">
                <div v-if="quote.status != 'granted' && !quote.business_invitation.is_awarded">
                  <b-form
                  class=""
                  @submit.prevent="submitTenderFormSubmitted"
                  v-if="quote.business_invitation && quote.business_invitation.status == 'newly_invited' || quote.business_invitation.status == 'edit_bid_accepted'"
                >
                  <h2 class="font-weight-bold">Submit bid</h2>
                  <p class="mb-0">Please fill in the details below</p>

                  <hr class="my-2">

                  <b-form-group label="Amount (*)">
                    <b-form-input
                      type="text"
                      placeholder="$"
                      v-model="submitTenderForm.amount"
                      v-bind:class="{
                        'is-invalid': submitTenderForm.errors.has('amount'),
                      }"
                    ></b-form-input>
                    <has-error
                      :form="submitTenderForm"
                      field="amount"
                    ></has-error>
                    <small
                      v-if="quote.business_invitation.tender_submitting_user"
                      >Submitted by:
                      {{
                        quote.business_invitation.tender_submitting_user
                          .full_name
                      }}</small
                    >
                  </b-form-group>

                  <b-form-group label="Due By" v-slot="{ ariaDescribedby }">
                    <date-picker
                      valueType="format"
                      v-model="submitTenderForm.due_date"
                      :format="'YYYY-MM-DD'"
                      :hide-header="true"
                      :aria-describedby="ariaDescribedby"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }"
                      placeholder="Due Date"
                      v-bind:class="{
                        'is-invalid': submitTenderForm.errors.has('due_date'),
                      }"
                    ></date-picker>
                    <has-error
                      :form="submitTenderForm"
                      field="due_date"
                    ></has-error>
                  </b-form-group>

                  <b-form-group label="Comments">
                    <b-form-textarea
                      cols="4"
                      rows="4"
                      v-model="submitTenderForm.comment"
                      v-bind:class="{
                        'is-invalid': submitTenderForm.errors.has('comment'),
                      }"
                      placeholder="Leave comment here..."
                    >
                    </b-form-textarea>
                    <has-error
                      :form="submitTenderForm"
                      field="comment"
                    ></has-error>
                    <small
                      v-if="quote.business_invitation.tender_submitting_user"
                      >Submitted by:
                      {{
                        quote.business_invitation.tender_submitting_user
                          .full_name
                      }}</small
                    >
                  </b-form-group>

                  <label class="form-labe">Attach files or document(s)</label>
                  <b-form-group class="position-relative">
                    <p class="upload-tab">
                      <SvgIcons
                        icon="upload-document-button"
                        width="25px"
                        height="20px"
                        svgClass="upload-docs"
                      />

                    </p>

                    <b-form-file
                      class="mb-4"
                      placeholder="Click here to browse file(s) or document(s)"
                      multiple
                      @change="attachementsChanged($event, 'file')"
                    ></b-form-file>
                  </b-form-group>
                  <b-row>
                    <div class="up-box d-flex mt-2 mr-1 ml-2"
                      v-for="(file, idx2) in submitTenderForm.attachments"
                      :key="'qd-file' + '-' + idx2"
                    >
                      <a>{{ file.name }}</a>
                      <SvgIcons
                        icon="insurance-document-close"
                        svgClass="ml-2"
                        style="margin-top: 2px"
                        @click.native="removeMedia(file, 'document')"
                      />
                    </div>
                  </b-row>

                  <b-button
                    class="mt-4"
                    variant="primary"
                    type="submit"
                  >
                    Update
                  </b-button>
                  </b-form>
                </div>
                <div v-else-if="quote.status == 'granted' && quote.business_invitation.is_awarded">
                  <p style="color:#1f911f;margin-top: 10px;font-size: 14px;">Congratulation, You are awarded to this quote.</p>
                  <div class="mt-4"><hr /></div>
                </div>
                <div v-else>
                  <p style="color:rgb(233, 22, 22); margin-top: 10px; font-size: 14px;">Sorry, The quote is already awarded to other contractor.</p>
                 <div class="mt-4"><hr /></div>
                </div>
              </div>


              <!-- After Form Submitted -->
              <div v-if="quote.status != 'granted'">
                <div v-if="quote.business_invitation && quote.business_invitation.status == 'bid_placed' || quote.business_invitation.status == 'edit_bid_requested' || quote.business_invitation.status == 'edit_bid_rejected'">
                  <!-- Bid Submission Notification -->
              <div class="submission-div">
                  <div class="notify-text">
                      <h3 style="color: #333;">Submitted</h3>
                      <p style="color: #767B80;margin-bottom: 0;">Your Bid has been submited</p>
                  </div>
                  <div class="notify-icon">
                      <i class="far fa-check-circle fa-3x"></i>
                  </div>
              </div>
              <!-- Bid Submission Notification ends -->

                <div class="my-3"><hr /></div>

                <div>
                    <b-alert
                    v-if="quote.business_invitation.status == 'edit_bid_rejected'"
                    :show="8"
                    dismissible
                    variant="danger"
                  >
                  Your bid request was rejected. You can resend update bid request.
                  </b-alert>
                </div>

                <b-row>
                    <b-col>
                        <div class="bid-details">
                            <h5 class="font-weight-bold">Bid Summary</h5>
                            <!-- ul -->
                            <ul>
                                <li>
                                    <span class="title">Amount:</span>
                                    <span class="sub-title">${{ submitTenderForm.amount }}</span>
                                </li>

                                <li>
                                    <span class="title">Posted Date:</span>
                                    <span class="sub-title">{{submitTenderForm.created_at}}</span>
                                </li>

                                <li>
                                    <span class="title">Due by:</span>
                                    <span class="sub-title">{{submitTenderForm.due_date}}</span>
                                </li>

                                <li>
                                    <span class="title">Comment:</span>
                                    <span class="sub-title">{{submitTenderForm.comment}}</span>
                                </li>

                                <li>
                                    <span class="title">Documents:</span>
                                    <span class="sub-title" v-for="(file, idx2) in submitTenderForm.attachments" :key="'ins-file' + idx2">
                                      <a target="_blank" download :href="file.signed_url">
                                        {{ file.name }}
                                      </a>
                                    </span>
                                </li>
                            </ul>
                            <!-- ul ends -->
                        </div>
                    </b-col>

                    <div v-if="quote.status_parsed != 'over-due'">
                        <div v-if="quote.status == 'granted' && !quote.business_invitation.is_awarded">
                            <h2 style="color:#4682B4">This quote is already awarded.</h2>
                        </div>

                        <div v-if="quote.business_invitation.status == 'bid_placed' || quote.business_invitation.status == 'edit_bid_rejected'" @click="confirmContactManagerToUpdate()" style="position: relative; top: 40px;">
                            <i
                                class="fas fa-unlock-alt fa-3x mb-2"
                                style="
                                color: #54D854;
                                cursor: pointer;position: relative;left: 80px;">
                            </i>
                            <span style=" display: block; cursor: pointer"
                            >Contact strata <br> manager to update</span>
                        </div>

                        <div v-if="quote.business_invitation.status == 'edit_bid_requested'" style="position: relative; top: 40px;">
                            <i class="far fa-check-circle fa-3x" style="color: #54D854;position: relative;left: 33px;"></i>
                            <span style="display: block;cursor:pointer;color: color: #767B80;">Update Bid <br> Request Sent</span>
                        </div>
                    </div>
                </b-row>

                <!-- <b-row>
                  <div
                    class="up-box d-flex mt-2 mr-1 ml-2"
                    v-for="(file, idx2) in submitTenderForm.attachments"
                    :key="'ins-file' + idx2"
                  >
                    <a target="_blank" download :href="file.signed_url">
                        {{ file.name }}
                      </a>
                  </div>
                </b-row> -->

                </div>
              </div>

              <!-- if is public quotes and needs to send expression of interest -->
              <div v-if="!quote.business_invitation">
                <b-alert
                  v-if="quote.business_interest"
                  show
                  dismissible
                  variant="success"
                >
                  Your bid update request has been sent.
                </b-alert>
                <b-button
                  v-if="
                    !quote.business_interest && !expressionOfInterestSuccess
                  "
                  @click="confirmExpressInterest()"
                  class="col-md-5"
                  variant="primary"
                  type="submit"
                  style="border-radius: 5px; padding: 5px 8px"
                >
                  Submit Express of Interest
                </b-button>
                <b-button
                  v-if="quote.business_interest || expressionOfInterestSuccess"
                  @click="confirmExpressInterest()"
                  class="col-md-5"
                  variant="primary"
                  type="submit"
                  style="border-radius: 5px; padding: 5px 8px"
                  :disabled="true"
                >
                  Interest Submitted
                </b-button>
                <hr>
              </div>

            </div>


            <!-- Schedule Inspection -->
            <div v-if="workOrder && !quote.schedule_inspection">
              <div class="text-center" v-if="!quote.schedule_inspection">
                <b-button
                  variant="primary"
                  class="btn py-3 font-weight-bold"
                  style="font-size: 14px; border-radius: 32px"
                  @click="showInspectionDetailForm = true"
                  >Schedule Inspection</b-button
                >
                <!-- <div class="mt-4"><hr /></div> -->

              </div>
              <div v-if="showInspectionDetailForm">
                <div class="mb-4">
                  <h2>Inspection Details</h2>
                  <span>Brief information on workorder initiation</span>
                </div>

                <b-form @submit.prevent="submitInspectionDetailForm">
                  <b-form-group
                    label="Date and time"
                    v-slot="{ ariaDescribedby }"
                  >
                    <date-picker
                      valueType="format"
                      v-model="inspectionDetailForm.due_date"
                      :format="'YYYY-MM-DD'"
                      :hide-header="true"
                      :aria-describedby="ariaDescribedby"
                      :date-format-options="{
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }"
                      placeholder="Due Date"
                      v-bind:class="{
                        'is-invalid':
                          inspectionDetailForm.errors.has('dateTime'),
                      }"
                    ></date-picker>
                    <has-error
                      :form="inspectionDetailForm"
                      field="dateTime"
                    ></has-error>
                  </b-form-group>

                  <b-form-group label="Description">
                    <b-form-textarea
                      cols="4"
                      rows="4"
                      v-model="inspectionDetailForm.description"
                      v-bind:class="{
                        'is-invalid':
                          inspectionDetailForm.errors.has('description'),
                      }"
                      placeholder="Leave comment here..."
                    >
                    </b-form-textarea>
                    <has-error
                      :form="inspectionDetailForm"
                      field="description"
                    ></has-error>
                  </b-form-group>

                  <b-button
                    class="col-md-4"
                    variant="primary"
                    type="submit"
                    style="border-radius: 5px"
                  >
                    Save
                  </b-button>
                </b-form>
                <hr class="my-3">
              </div>
            </div>

            <hr class="my-3">
            <!-- Quote Detail Content -->
            <div class="deatil-content">
              <h5 style="font-size: 18px">Details</h5>

              <ul>
                  <li v-if="quote.site_contact_name">
                      <span class="title">Site contact name:</span>
                      <span class="sub-title">{{quote.site_contact_name}}</span>
                  </li>

                  <li v-if="quote.site_contact_name">
                      <span class="title">Site contact name:</span>
                      <span class="sub-title">{{quote.site_contact_name}}</span>
                  </li>

                  <li v-if="quote.site_access_email">
                      <span class="title" style="flex: 0 0 130px;">Site access email:</span>
                      <span class="sub-title">{{quote.site_access_email}}</span>
                  </li>

                  <li>
                      <span class="title">Date Posted:</span>
                      <span class="sub-title">{{ quote.created_at }}</span>
                  </li>

                  <li v-if="quote.due_date">
                      <span class="title">Due by:</span>
                      <span class="sub-title">{{ quote.due_date }}</span>
                  </li>

                  <li>
                      <span class="title">Address:</span>
                      <span class="sub-title">{{quote.strata_plan.street}}, {{quote.strata_plan.suburb}}, {{quote.strata_plan.state}} {{quote.strata_plan.postcode}}</span>
                  </li>

                  <li v-if="quote.address_note">
                      <span class="title" style="flex: 0 0 130px;">Address Note:</span>
                      <span class="sub-title">{{ quote.address_note }}</span>
                  </li>

<!--                  <li>-->
<!--                      <span class="title">Budget Estimated :</span>-->
<!--                      <span class="sub-title"><span v-if="!workOrder"-->
<!--                  >${{ quote.min_estimate_budget }} - -->
<!--                </span>-->
<!--                ${{ quote.max_estimate_budget }}</span>-->
<!--                  </li>-->
              </ul>

              <!-- <p v-if="quote.site_contact_name">Site contact name: {{quote.site_contact_name}}</p>
              <p v-if="quote.site_access_contact">Site access contact: {{quote.site_access_contact}}</p>
              <p v-if="quote.site_access_email">Site access email: {{quote.site_access_email}}</p>
              <p>Date Posted: {{ quote.created_at }}</p>
              <p v-if="quote.due_date">Due by: {{ quote.due_date }}</p>
              <p>Address: {{quote.strata_plan.street}}, {{quote.strata_plan.suburb}}, {{quote.strata_plan.state}} {{quote.strata_plan.postcode}}</p>
              <p v-if="quote.address_note">Address Note: {{ quote.address_note }}</p>
              <p>
                Budget Estimated :
                <span v-if="!workOrder"
                  >${{ quote.min_estimate_budget }} -
                </span>
                ${{ quote.max_estimate_budget }}
              </p> -->
            </div>

            <div class="deatil-content" v-if="quote.schedule_inspection">
              <hr class="my-3">
              <h5 style="font-size: 18px" class="pb-2">Inspection Details</h5>
              <p>Date: {{ quote.schedule_inspection.due_date }}</p>
              <p>Description: {{ quote.schedule_inspection.description }}</p>
            </div>

            <hr class="my-3">
            <h5 style="font-size: 18px; color: #333333">File(s)</h5>
            <div class="d-flex">
              <a
                style="
                  text-decoration: underline;
                "
                v-for="(file, index) in quote.attachments"
                :key="index"
                :href="file.signed_url"
                download
                >{{ file.name }}</a
              >&nbsp;
            </div>
            <hr class="my-3">

            <h5 style="font-size: 18px; color: #333333" class="my-2">
              Worksite image(s):
            </h5>
            <b-row>
              <b-col
                md="6"
                v-for="(photo, index) in quote.site_photos"
                :key="index"
              >
                <img
                  :src="photo.signed_url"
                  class="img-fluid mb-4"
                  :style="{ height: '150px' }"
                  @click="handleWorkSiteImageClick(photo.signed_url)"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

        <b-row>
            <b-col class="pl-lg-5 px-md-5 mt-3 mb-2">
            <footer-component></footer-component>
            </b-col>
        </b-row>
    </b-container>
  </div>
  </b-overlay>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import { Form, HasError } from "vform";
import moment from "moment";
import Swal from "sweetalert2";
import SvgIcons from "@frontendPages/includes/SvgIconsComponent.vue";
import axios from "axios";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin";
import FooterComponent from "../../../includes/FooterComponent.vue";

import {
  addDoc,
  doc,
  collection,
  getDocs,
  setDoc,
  limit,
  where,
  query,
  orderBy,
  onSnapshot,
  startAfter,
  endAt,
  endBefore,
  limitToLast,
  updateDoc,
} from "firebase/firestore";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

Vue.component(HasError.name, HasError);

export default {
  components: {
    NavBar,
    SvgIcons,
    HasError,
    FooterComponent,
  },
  props: {
    workOrder: String,
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      applyQuoteForm: new Form({
        amount: "",
        id: this.$route.params.id,
        manager_id: "",
      }),
      submitTenderForm: new Form({
        business_invitation_id: "",
        quote_id: "",
        amount: "",
        due_date: null,
        created_at: "",
        comment: "",
        attachments: [],
      }),
      inspectionDetailForm: new Form({
        quote_id: this.$route.params.id,
        due_date: null,
        description: "",
      }),
      invoiceDetailForm: new Form({
        quote_id: this.$route.params.id,
        variation: "",
        comment: "",
        total_amount: "",
      }),
      showInspectionDetailForm: false,
      quote: {
        business: {},
        strata_plan: {},
        business_invitation: {
          sending_business: {},
          status: "",
        },
        schedule_inspection: {},
        progress_percentage: "",
      },
      applyQuotes: [],
      applyQuotesFields: [
        { key: "ManagerName", sortable: true },
        { key: "Amount", sortable: true },
        { key: "Action", sortable: true },
      ],
      showInterestField: [{ key: "Action", sortable: true }],

      //Work Order
      progressFileItems: [],
      progressFileFields: [
        {
          key: "Progress",
          sortable: true,
          // thStyle: { background: "#4682b4", color: "#ffffff" },
        },
        {
          key: "Description",
          sortable: true,
          // thStyle: { background: "#4682b4", color: "#ffffff" },
        },
        {
          key: "Date",
          sortable: true,
          // thStyle: { background: "#4682b4", color: "#ffffff" },
        },
        {
          key: "By",
          sortable: true,
          // thStyle: { background: "#4682b4", color: "#ffffff" },
        },
        {
          key: "Download",
          sortable: true,
          // thStyle: { background: "#4682b4", color: "#ffffff" },
        },
      ],
      addProgress: false,
      progressForm: new Form({
        quote_id: this.$route.params.id,
        percentage: 10,
        description: "",
        attachment: "",
      }),
      percentageOptions: [
        { value: 10, text: "10%" },
        { value: 20, text: "20%" },
        { value: 30, text: "30%" },
        { value: 40, text: "40%" },
        { value: 50, text: "50%" },
        { value: 60, text: "60%" },
        { value: 70, text: "70%" },
        { value: 80, text: "80%" },
        { value: 90, text: "90%" },
        { value: 100, text: "100%" },
      ],
      awardedTenderItems: [],
      awardedTenderFields: [
        { key: "CompanyName", sortable: true },
        // { key: "Compliance", sortable: true },
        { key: "Amount", sortable: true },
        { key: "Files", sortable: true },
        { key: "Message", sortable: true },
      ],
      counts: {},
      showMarkComplete: false,
      userInvited: false,
      updateBidRequest: false,
      interestSent: false,
      amountAppliedSuccessMessage: "",
      expressionOfInterestSuccess: false,
      subtractedDate: "",
      invoiceSent: false,

      activeTab: "",

      //chat
      activeChatBoxInfo: {
        chatId: "",
        receiverBusinessDetails: {
          id: "",
          company_name: "",
        },
        senderBusinessDetails: {
          id: "",
          company_name: "",
        },
      },
      chatMessageInfo: {},
      chatMessages: [],
      message: "",
      latestDoc: null,
    };
  },
  mounted() {
    this.fetchQuote(this.$route.params.id);
    this.getProgressDetails();
    this.getCounts();

    if(!this.workOrder){
      this.activeTab = "chat";
    }

    //For Firebase
    this.$el
      .querySelector("#chat-message")
      .addEventListener("scroll", this.handleScroll);
  },
  methods: {
    fetchQuote(id) {
      axios
        .post("api/contractor/quote/getDetails", {
          id: id,
          load_strata_plan: 1,
          load_business_interest: 1,
          load_business_invitation: 1,
          load_business_invitation_sending_business: 1,
          load_business_invitation_tender_submitting_user: 1,
          load_user_invitation: 1,
          load_categories: 1,
          load_media_site_photos: 1,
          load_media_attachments: 1,
          load_schedule_inspection: 1,
          load_invoice_details: 1,
        })
        .then((response) => {
          this.quote = response.data.quote;
          this.quote.status_date = moment(
            response.data.quote.status_date
          ).format("D MMM YYYY");

          if (this.quote.business_invitation) {
            this.invoiceDetailForm.total_amount =
              this.quote.business_invitation.amount * 0.1 +
              this.quote.business_invitation.amount;
          }

          //Changing date format of schedule inspection
          if (this.quote.schedule_inspection) {
            this.quote.schedule_inspection.due_date = moment(
              response.data.quote.schedule_inspection.due_date
            ).format("D MMM YYYY");
          }

          this.fillSubmitTenderFormData();

          //Remaining Days for due soon quote
          if (this.quote.status_parsed == "due") {
            var dueDate = moment(response.data.quote.due_date).add(1, "days");
            var currentDate = moment();
            this.subtractedDate = dueDate.diff(currentDate, "days"); // 1
          }

          //Passed Days for due soon quote
          if (this.quote.status_parsed == "over-due") {
            var dueDate = moment(response.data.quote.due_date);
            var currentDate = moment();
            this.subtractedDate = currentDate.diff(dueDate, "days"); // 1
          }

          //For Date Format
          this.dateFormat(response.data.quote, "createdAt");
          this.dateFormat(response.data.quote, "dueDate");

          this.quote.site_access_contact = response.data.quote.site_contact
            ? this.formatPhoneForAustraliaBySpace(
                response.data.quote.site_contact
              )
            : "";

          //Initializing for chat messages
          this.activeChatBoxInfo.receiverBusinessDetails = this.quote.business_invitation.sending_business;
          this.activeChatBoxInfo.senderBusinessDetails = this.quote.business;
          this.activeChatBoxInfo.chatId = response.data.quote.business_invitation.id;

          this.getMessageFromFireBase(this.activeChatBoxInfo.chatId);
        });
    },
    getCounts() {
      axios
        .post("api/contractor/quote/getCounts", {
          quote_id: this.$route.params.id,
          jobType: this.workOrder ? "work-order" : "quote",
        })
        .then((response) => {
          this.counts = response.data;
        });
    },
    dateFormat(quote, date_type) {
      if (date_type == "createdAt") {
        var newDate = new Date(quote.created_at);
      }
      if (date_type == "dueDate") {
        var newDate = new Date(quote.due_date);
      }

      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var MonthName = months[newDate.getMonth()];
      var year = newDate.getFullYear();
      var date = newDate.getDate();
      var datePosted = date + " " + MonthName + " " + year;

      if (date_type == "createdAt") {
        return (quote.created_at = datePosted);
      } else if (date_type == "dueDate") {
        return (quote.due_date = datePosted);
      }
    },
    applyNow() {
      this.applyQuoteForm
        .post("api/contractor/quote/applyQuotes")
        .then((response) => {
          this.amountAppliedSuccessMessage = response.data.message;
          this.applyQuoteForm.amount = "";
        });
    },
    fillSubmitTenderFormData() {
      this.quote.business_invitation &&
        this.submitTenderForm.fill({
          business_invitation_id: this.quote.business_invitation.id,
          quote_id: this.$route.params.id,
          amount: this.quote.business_invitation.amount,
          comment: this.quote.business_invitation.comments,
          due_date: this.quote.business_invitation.due_date
            ? moment(this.quote.business_invitation.due_date).format(
                "YYYY-MM-DD"
              )
            : null,
          created_at: moment(this.quote.business_invitation.created_at).format(
            "D MMM YYYY"
          ),
          attachments: this.quote.business_invitation.bidding_file,
        });
    },
    submitTenderFormSubmitted() {
      this.$root.$data.bsLoader = true;
      this.submitTenderForm
        .post("api/contractor/quote/submitTender")
        .then((response) => {
          Swal.fire({
            title: response.data.message,
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });

          this.submitTenderForm.due_date = moment(
            response.data.quote_business.due_date
          ).format("D MMM YYYY");
          this.submitTenderForm.created_at = moment(
            response.data.quote_business.created_at
          ).format("D MMM YYYY");

          this.quote.business_invitation.status = "bid_placed";
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },
    confirmExpressInterest() {
      this.$bvModal
        .msgBoxConfirm("Are you sure want to submit express of interest?", {
          title: "Confirmation",
          size: "md",
          okVariant: "primary",
          cancelVariant: "danger",
          okTitle: "YES",
          buttonSize: "md",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          value && this.expressInterest();
        })
        .catch((err) => {
          // An error occurred
        });
    },
    expressInterest() {
      axios
        .post("api/contractor/quote/expressInterest", {
          quote_id: this.$route.params.id,
        })
        .then((response) => {
          Swal.fire({
            title: response.data.message,
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
          this.expressionOfInterestSuccess = true;
        });
    },
    confirmContactManagerToUpdate() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure want to contact strata manager to update?",
          {
            title: "Confirmation",
            size: "md",
            okVariant: "primary",
            cancelVariant: "danger",
            okTitle: "YES",
            buttonSize: "md",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          value && this.contactManagerToUpdate();
        })
        .catch((err) => {
          // An error occurred
        });
    },
    contactManagerToUpdate() {
      axios
        .post("api/contractor/quote/contactManagerToUpdate", {
          pivot_quote_business: this.submitTenderForm.business_invitation_id,
        })
        .then((response) => {
          this.quote.business_invitation.status = "edit_bid_requested";
          Swal.fire({
            title: "Update bid request sent.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        });
    },
    attachementsChanged: function (event, file_type) {
      if (!event.target.files.length) return;
      var input = event.target.files;

      //For Attachment
      input &&
        _.forEach(input, (file) => {
          const formData = new FormData(); //For uploading in storage
          formData.append("upload", file);
          formData.append(
            "quote_business_id",
            this.quote.business_invitation.id
          );
          formData.append("file_type", file_type);

          axios
            .post("api/contractor/quote/addMediaToQuote", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              let extension = file.name.split(".").pop();
              if (file_type == "file") {
                this.submitTenderForm.attachments.push({
                  extension: extension,
                  name: file.name,
                  uuid: response.data.uuid,
                });
              }
            });
        });
      event.target.value = "";
    },
    progressFileAttachements: function (event, file_type) {
      if (!event.target.files.length) return;
      var document = event.target.files[0];
      this.progressForm.attachment = document;
    },
    submitInspectionDetailForm() {
      this.inspectionDetailForm
        .post("api/contractor/workorder/submitScheduleInspection")
        .then((response) => {
          this.quote.schedule_inspection = response.data.schedule_inspection;
          this.quote.schedule_inspection.due_date = moment(
            response.data.schedule_inspection.due_date
          ).format("D MMM YYYY");
          Swal.fire({
            title: "Inspection details saved successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        });
    },
    submitProgressForm() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Are you sure want to add progress file?", {
          title: "Confirmation",
          size: "md",
          okVariant: "primary",
          cancelVariant: "danger",
          okTitle: "YES",
          buttonSize: "md",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          const data = new FormData();
          data.append("quote_id", this.progressForm.quote_id);
          data.append("percentage", this.progressForm.percentage);
          data.append("attachment", this.progressForm.attachment);
          data.append("description", this.progressForm.description);

          axios
            .post("api/contractor/workorder/submitProgress", data)
            .then((response) => {
              this.progressFileItems.push({
                quote: response.data.quote,
                Progress: response.data.quote.percentage + "%",
                Description: response.data.quote.description,
                Date: moment(response.data.quote.created_at).format(
                  "D MMM YYYY"
                ),
                By:
                  response.data.quote.marking_user.first_name +
                  " " +
                  response.data.quote.marking_user.last_name,
                Download: "",
              });

              Swal.fire({
                title: "Inspection details saved successfully.",
                icon: "success",
                timer: 3000,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
              });

              //Disabling mark complete button if status is complated
              if (response.data.quote.percentage == 100) {
                this.quote.progress_percentage = 100;
                this.showMarkComplete = true;
              }

              this.addProgress = false;
              //Resetting Form
              this.progressForm.description = "";
              this.progressForm.attachment = "null";
            })
            .catch((error) => {
              if (error.response?.data?.errors) {
                this.progressForm.errors.errors = error.response.data.errors;
              }
            });
        })
        .catch((err) => {
          // An error occurred
        });
    },
    getProgressDetails() {
      this.activeTab = "";
      axios
        .post("api/contractor/quote/getDetails", {
          id: this.$route.params.id,
          load_progress_details: 1,
        })
        .then((response) => {
          this.progressFileItems = _.map(
            response.data.quote.progresses,
            function (progressDetails) {
              if (progressDetails.percentage != null) {
                return {
                  quote: progressDetails,
                  Progress: progressDetails.percentage + "%",
                  Description: progressDetails.description,
                  Date: moment(progressDetails.created_at).format("D MMM YYYY"),
                  By:
                    progressDetails.marking_user.first_name +
                    " " +
                    progressDetails.marking_user.last_name,
                  Download: " ",
                };
              }
            }
          );

          //show mark complete button
          if (
            response.data.quote.progress_percentage == 100 &&
            response.data.quote.status != "verify-completed"  && response.data.quote.status != "completed"
          ) {
            this.showMarkComplete = true;
          }

          this.progressFileItems = this.progressFileItems.filter(function (
            element
          ) {
            return element !== undefined;
          });
        });
    },
    confirmMarkComplete() {
      this.$bvModal
        .msgBoxConfirm("Are you sure want to mark complete this quote?", {
          title: "Confirmation",
          size: "md",
          okVariant: "primary",
          cancelVariant: "danger",
          okTitle: "YES",
          buttonSize: "md",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          value && this.handleSubmitMarkComplete();
          // value && this.awardTender(pivot_quote_business);
        })
        .catch((err) => {
          // An error occurred
        });
    },
    handleSubmitMarkComplete() {
      axios
        .post("api/contractor/workorder/markComplete", {
          quote_id: this.$route.params.id,
        })
        .then((response) => {
          this.quote.status = response.data.quote.status;
          this.quote.status_date = moment(
            response.data.quote.status_date
          ).format("D MMM YYYY");
          this.showMarkComplete = false;

          Swal.fire({
            title: "Mark Completed successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });
        });
    },
    getAwardedTenders() {
      this.activeTab = "";
      axios
        .post("api/contractor/quote/getDetails", {
          id: this.$route.params.id,
          load_awarded_tender: 1,
          load_awarded_tender_sending_business: 1,
        })
        .then((response) => {
          this.awardedTenderItems = [
            {
              awardedTenderDetails: response.data.quote.awarded_tender,
              CompanyName: response.data.quote.awarded_tender.sending_business.company_name,
              // Compliance: "Complaint",
              Amount: response.data.quote.awarded_tender.amount
                ? "$ " + response.data.quote.awarded_tender.amount
                : "No Amount",
              business: this.quote.business,
              pivot: this.quote.business_invitation,
              Files: "",
              Message: "",
              unread_count: 0,
            },
          ];

          if(this.awardedTenderItems.length > 0){
            this.getUuidForUnreadMessageCount(this.awardedTenderItems);     //Get All Uuid of of contractor related to active tabs
            this.checkForUnreadChatOnInvitations(this.awardedTenderItems);                              // Check for unread chat for notifications
          }
        });


    },
    submitInvoiceDetailForm() {
      this.invoiceDetailForm
        .post("api/contractor/workorder/submitInvoiceForm")
        .then((response) => {
          this.quote.quote_invoice = response.data.quote.quote_invoice;
          this.invoiceSent = true;
        });
    },
    closeModal() {
      this.$bvModal.hide("invoice-modal");
      this.invoiceSent = false;
    },
    showPreview(variation) {
      this.$bvModal.show("preview-invoice");
    },

    openChat(uuid, chat_with_business_details, my_business_details, contractor_of) {
      this.activeTab = "chat";
      // this.initializeChatBoxInfo(uuid, chat_with_business_details, my_business_details, contractor_of);
      this.getMessageFromFireBase(uuid);
      setTimeout(() => {
        this.scrollToBottom();
      }, 300);

       this.activeTab == "chat" && this.updateUnreadToReadMessages(uuid);   //For updating unread messages to read
    },

    getUuidForUnreadMessageCount(contractors) {
      var uuids = [];
      contractors.forEach((item) => {
        uuids.push(item.pivot.id);
      });
      this.uuids = uuids;
    },

    checkForUnreadChatOnInvitations(contractors) {
      // check unread chat messages
      let messageQuery = query(
        collection(this.$root.fireStore, "chat-message-info"),
        where("receiving_business_id", "==", this.activeChatBoxInfo.senderBusinessDetails.id),
        where("chat_id", "in", this.uuids),
        where("read", "==", false)
      );

      onSnapshot(messageQuery, (querySnapshot) => {
        var allMessages = [];
        querySnapshot.forEach((snap) => {
          console.log(snap.data())
          allMessages.push(snap.data());
        });

        contractors.forEach((item, index) => {
          let sameUuid = _.filter(allMessages, ["chat_id", item.pivot.id]);
          let countUnreadMessages = sameUuid.length;
          contractors[index].unread_count = countUnreadMessages;
        });
      });
    },

    // previewInvoice starts
    previewInvoiceDetails() {
      axios({
        url: "api/contractor/workorder/preview-invoice-pdf",
        method: "post",
        responseType: "blob",
        data: {
          format: "pdf",
          quote_id: this.$route.params.id,
        },
      }).then((response) => {
        var blob = new Blob([response.data], { type: "application/pdf" });
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
    // previewInvoice ends

    async getMessageFromFireBase(uuid) {
      var messageQuery = query(
        collection(this.$root.fireStore, "chat-message-info"),
        where("chat_id", "==", this.activeChatBoxInfo.chatId),
        // where("quote_no", "==", this.$route.params.id),
        orderBy("timestamp", "desc"),
        endAt(this.latestDoc ? this.latestDoc.timestamp : 0),
        limit(10)
      );

    setTimeout(() => {
        onSnapshot(messageQuery, (querySnapshot) => {
          let allMessages = [];
          querySnapshot.forEach((snap) => {
            allMessages.push(snap.data());
          });

          this.chatMessages = allMessages;
          this.chatMessages.reverse();

        setTimeout(() => {
          this.scrollToBottom();
          this.activeTab == "chat" && this.updateUnreadToReadMessages(uuid);        //Update message to read when user is on chatbox
        }, 2000)
        });
      }, 100);
    },
    async updateUnreadToReadMessages(uuid) {
      let messageQuery = query(
        collection(this.$root.fireStore, "chat-message-info"),
        where('receiving_business_id', "==", this.activeChatBoxInfo.senderBusinessDetails.id),
        where("chat_id", "==", uuid),
        where("read", "==", false)
      );
      var getDocument = await getDocs(messageQuery);
      getDocument.forEach(async (item) => {
        let document = doc(this.$root.fireStore, "chat-message-info", item.id);
        await updateDoc(document, {
          read: true,
        });
      });
    },
    async loadMoreMessages() {
      var messageQuery = query(
        collection(this.$root.fireStore, "chat-message-info"),
        where("chat_id", "==", this.activeChatBoxInfo.chatId),
        where("sending_business_id", "in", [
          this.activeChatBoxInfo.receiverBusinessDetails.id,
          this.activeChatBoxInfo.senderBusinessDetails.id,
        ]),
        where("timestamp", "!=", this.latestDoc.timestamp),
        orderBy("timestamp"),
        endAt(this.latestDoc ? this.latestDoc.timestamp : 0),
        limitToLast(11)
      );

      const unsubscribe = onSnapshot(messageQuery, (querySnapshot) => {
        var moreMessages = [];
        querySnapshot.forEach((snap, index) => {
          moreMessages.push(snap.data());
        });

        //Reversing loaded messages and pushed into chat messages
        moreMessages.reverse();
        moreMessages.forEach((message) => {
          this.chatMessages.unshift(message);
        });
      });
    },
    async sendMessage() {
      //Sending new message to firestore collection
      this.message &&
        (await addDoc(collection(this.$root.fireStore, "chat-message-info"), {
          type: "message",
          message: this.message,
          chat_id: this.activeChatBoxInfo.chatId,
          receiving_business_id:
            this.activeChatBoxInfo.receiverBusinessDetails.id,
          receiving_business_details:
            this.activeChatBoxInfo.receiverBusinessDetails,
          receiving_user_details: _.pick(
            this.activeChatBoxInfo.receiverBusinessDetails.owner,
            [
              "id",
              "first_name",
              "last_name",
              "email",
              "first_name",
              "phone",
              "first_name",
            ]
          ),
          sending_business_id: this.activeChatBoxInfo.senderBusinessDetails.id,
          sending_business_details:
            this.activeChatBoxInfo.senderBusinessDetails,
          sending_user_details: _.pick(
            this.activeChatBoxInfo.senderBusinessDetails.owner,
            [
              "id",
              "first_name",
              "last_name",
              "email",
              "first_name",
              "phone",
              "first_name",
            ]
          ),
          quote_no: this.$route.params.id,
          read: false,
          timestamp: new Date(),
        }));

      setTimeout(() => {
        this.scrollToBottom();
      }, 200);

      //Emptying message input
      this.message = "";
    },
    sendAttachment: function (event, file_type) {
        console.log(event, file_type)
      if (!event.target.files.length) return;
      var input = event.target.files;

      input &&
        _.forEach(input, (file) => {
          if (file_type == "image") {
            let extension = file.name.split(".").pop();
            if (
              extension != "gif" &&
              extension != "png" &&
              extension != "bmp" &&
              extension != "jpeg" &&
              extension != "jpg"
            ) {
              Swal.fire({
                title: "Please upload valid image.",
                icon: "error",
                timer: 3000,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
              });
              return;
            }
          }

          let storageRef = ref(this.$root.storage, "chat-files/" + file.name);
          uploadBytes(storageRef, file).then(() => {
            getDownloadURL(storageRef).then(async (url) => {
              //Sending new message to firestore collection
              await addDoc(
                collection(this.$root.fireStore, "chat-message-info"),
                {
                  type: file_type,
                  chat_id: this.activeChatBoxInfo.chatId,
                  file_name: file.name,
                  message: url,
                  receiving_business_id:
                    this.activeChatBoxInfo.receiverBusinessDetails.id,
                  receiving_business_details:
                    this.activeChatBoxInfo.receiverBusinessDetails,
                  receiving_user_details: _.pick(
                    this.activeChatBoxInfo.receiverBusinessDetails.owner,
                    ["id", "first_name", "last_name", "email", "phone"]
                  ),
                  sending_business_id:
                    this.activeChatBoxInfo.senderBusinessDetails.id,
                  sending_business_details:
                    this.activeChatBoxInfo.senderBusinessDetails,
                  sending_user_details: _.pick(
                    this.activeChatBoxInfo.senderBusinessDetails.owner,
                    ["id", "first_name", "last_name", "email", "phone"]
                  ),
                  quote_no: this.$route.params.id,
                  timestamp: new Date(),
                }
              );

              setTimeout(() => {
                this.scrollToBottom();
              }, 3000);
            });
          });
        });
    },
    handleScroll() {
      if (this.$el.querySelector("#chat-message").scrollTop == 0) {
        this.latestDoc = this.chatMessages[0];
        this.$el
          .querySelector("#chat-message")
          .firstChild.setAttribute("id", "lastMessage");

        this.loadMoreMessages();

        //Scrolling to last message of pagination
        setTimeout(() => {
          document
            .getElementById("lastMessage")
            .scrollIntoView({ behavior: "smooth", block: "nearest" });
        }, 200);
      }
    },
    scrollToBottom() {
      let container = this.$el.querySelector("#chat-message");
      container.scrollTop = container.scrollHeight;
    },
    momentDate: function (timestamp) {
      let date = new Date(timestamp.seconds * 1000);
      return moment(date).format("D MMM YYYY | LT");
    },
    newline() {
      this.message = `${this.message}`;
    },
  },
};
</script>

<style>
.b-table-empty-row {
  text-align: center;
}
.modal-backdrop {
  background-color: #00000094;
}
.btn:focus,
.btn.focus {
  box-shadow: none;
}
/* .modal-header {
  display: block;
} */
.modal-header p {
  color: #767b80;
  margin-bottom: 0px;
}

#chat-message .sending-message {
  text-align: right;
}
.file {
  background: white;
  display: inline-block !important;
  /* padding: 7px 15px; */
  font-size: 16px;
  font-weight: bold;
  box-shadow: none;
  text-decoration: underline;
}
.file pre {
  color: #5f2eea !important;
  font-size: 14px;
}

.btn-public,
.btn-public:hover,
.btn-public:active {
    background: #00BA88 !important;
    color: #fff;
}

.job-detail ul li span.title {
    font-weight: 600;
}

.job-detail ul li span.sub-title,
.deatil-content ul li span.sub-title {
    margin-left: 10px;
}

.deatil-content ul li {
    display: flex;
    color: #828282;

}


.submission-div {
    display: flex;
}

.submission-div .notify-icon {
    margin-left: auto;
    color: #54D854;
}

.quote-status .open-btn {
    background: #54D854;
    color: #fff;
}

.bid-details ul li span.sub-title {
    margin-left: 10px;
}
</style>
